/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_transition_group_1 = require("react-transition-group");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./GenericTransition.css'); }
exports.Fade = function Fade(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return (React.createElement(react_transition_group_1.CSSTransition, tslib_1.__assign({ appear: true, mountOnEnter: true, unmountOnExit: true, classNames: "m-genericFade", timeout: 800 }, props), children));
};
exports.FadeScale = function FadeScale(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return (React.createElement(react_transition_group_1.CSSTransition, tslib_1.__assign({ appear: true, mountOnEnter: true, unmountOnExit: true, classNames: "m-genericFadeScale", timeout: 800 }, props), children));
};
exports.FadeToBottom = function FadeToBottom(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return (React.createElement(react_transition_group_1.CSSTransition, tslib_1.__assign({ appear: true, mountOnEnter: true, unmountOnExit: true, classNames: "m-genericFadeToBottom", timeout: 800 }, props), children));
};